import {
  FETCH_PAGOS,
  SEARCH_PAGOS,
  DETALLE_OP_SUCCESS,
  LOADING_PAGOS_END,
  LOADING_PAGOS,
  RESET_PAGOS,
  LOADING_DETAIL_END,
  LOADING_DETAIL,
} from '../constants/index';

function filterPagos(state, data) {
  return { ...state, ultimosPagos: data, ultimosPagosInit: data };
}
function filterSearchPagos(state, data) {
  return { ...state, ultimosPagos: data };
}
function resetPagos(state) {
  return { ...state, ultimosPagos: state.ultimosPagosInit };
}

const initialState = {
  ultimosPagos: null,
  ultimosPagosInit: [],
};

export default function facturas(state = initialState, action) {
  const newState = { ...state };
  switch (action.type) {
    case FETCH_PAGOS:
      return filterPagos(newState, action.pagos);
    case SEARCH_PAGOS:
      return filterSearchPagos(newState, action.pagos);
    case RESET_PAGOS:
      return resetPagos(newState);
    case DETALLE_OP_SUCCESS:
      newState.detallePagos = action.detalle;
      return newState;
    case LOADING_PAGOS_END:
      newState.loading = false;
      return newState;
    case LOADING_PAGOS:
      newState.loading = true;
      return newState;
    case LOADING_DETAIL_END:
      newState.loadingDetails = false;
      return newState;
    case LOADING_DETAIL:
      newState.loadingDetails = true;
      return newState;
    default:
      return newState;
  }
}
